export const extractScheduledDate = (message) => {
  const regex = /Fecha programada: (\d{2}\/\d{2}\/\d{4})/;
  const match = message.match(regex);
  return match ? match[1] : 'N/A';
};

export const removeScheduledDate = (message) => {
  return message
    .replace(/Fecha programada: \d{2}\/\d{2}\/\d{4}/, '')
    .replace(/^\|? Comentarios del pedido:/, '')
    .trim();
};

export const formatCurrency = (amount, shouldRound = true) => {
  return shouldRound ? `$${parseFloat(amount).toFixed(2)}` : `$${amount}`;
};

export const formatCurrencyWithoutSymbol = (amount, shouldRound = true) => {
  return shouldRound ? parseFloat(amount).toFixed(2) : amount.toString();
};
